/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetGrowRatesRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {GetGrowRatesResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const getGrowRates = (request: GetGrowRatesRequest, options?: CashRequestOptions) => post<GetGrowRatesRequest, GetGrowRatesResponse>("/cash-app/cashlite-orchestrator/grow/rates", request, {...options, rejectOnError: true })